import React, { Component } from "react";
import "./card.scss";
export default class Card extends Component {
  render() {
    return (
      <div className="card">
        <div className="title">{this.props.title}</div>
        <div className="children-content">{this.props.children}</div>
      </div>
    );
  }
}
